import DataType from '@opsbase/lib-datatype/DataType';
import i18n from '@opsbase/lib-i18n';
import Palette from '@opsbase/lib-palette';
import useOpDefinitions from '@opsbase/react-gql-hooks/opdefinition/useOpDefinitions';
import useQuestionSetDelete from '@opsbase/react-gql-hooks/questionset/useQuestionSetDelete';
import useQuestionSetFindById from '@opsbase/react-gql-hooks/questionset/useQuestionSetFindById';
import markdown from '@opsbase/react-markdown';
import useNewDataActions from '@opsbase/web-ctrl-newdata/useNewDataActions';
import useSelection from '@opsbase/web-data-selection/useSelection';
import useSelectionActions from '@opsbase/web-data-selection/useSelectionActions';
import ConfirmDialog from '@opsbase/web-dialogs/ConfirmDialog';
import Vertical from '@opsbase/web-layout/Vertical';
import useParams from '@opsbase/web-nav/useParams';
import useNotificationActions from '@opsbase/web-notification/useNotificationActions';
import Text from '@opsbase/web-ui/Text';
import Tooltip from '@opsbase/web-ui/Tooltip';
import React, { useCallback, useMemo } from 'react';
function QuestionSetDeleteDialog() {
    const { id } = useParams();
    const dataType = DataType.QUESTIONSET;
    const { selecteds } = useSelection(dataType);
    const { clearSelection } = useSelectionActions(dataType);
    const { raise } = useNotificationActions();
    const { removeItemsFromType } = useNewDataActions();
    const deleteQuestionSet = useQuestionSetDelete();
    const { loading, data } = useQuestionSetFindById({
        variables: { id },
        skip: id === 'selected',
    });
    const ids = useMemo(() => (id === 'selected' ? selecteds.map(o => o.id) : [id]), [id, selecteds]);
    const title = id === 'selected' ? selecteds.map(o => o.title).join(', ') : data === null || data === void 0 ? void 0 : data.title;
    const { loading: loadingOpDefs, data: opDefs } = useOpDefinitions({
        variables: {
            questionSet: ids,
        },
    });
    const handleAction = useCallback(async () => {
        clearSelection();
        return raise(Promise.all(ids.map(theId => deleteQuestionSet({ id: theId }))).then(() => removeItemsFromType(DataType.QUESTIONSET, selecteds)), i18n.t('questionset-delete-successful'));
    }, [clearSelection, deleteQuestionSet, ids, raise, removeItemsFromType, selecteds]);
    const text = markdown(i18n.t('confirm-questionset-delete', {
        title,
        count: ids.length,
    }));
    const text2 = !!(opDefs === null || opDefs === void 0 ? void 0 : opDefs.length)
        ? markdown(i18n.t('confirm-questionset-delete-used', {
            count: opDefs === null || opDefs === void 0 ? void 0 : opDefs.length,
        }))
        : '';
    return (React.createElement(ConfirmDialog, { onConfirm: handleAction, agreeText: i18n.t('delete'), notAgreeText: i18n.t('cancel'), color: Palette.error, loading: loading || loadingOpDefs },
        React.createElement(Vertical, { gutter: true },
            React.createElement(Text, null, text),
            !!text2 && (React.createElement(Tooltip, { interactive: true, tip: React.createElement(Vertical, { scrollY: true, padding: true, style: { maxHeight: 240 } },
                    React.createElement("ul", { style: { margin: 0, padding: 0 } }, opDefs === null || opDefs === void 0 ? void 0 : opDefs.map(o => (React.createElement("li", { key: o.id }, o.title))))) },
                React.createElement(Text, null, text2))))));
}
export default QuestionSetDeleteDialog;
